module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/agAgjK/tc-custom/9781442429048.jpg?1730492842148",
      "alt": "This image is the cover for the book Ready for a Scare?, You're Invited to a Creepover"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Ready for a Scare?, You're Invited to a Creepover\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Birthday girl and queen of all things spooky, Kelly Garcia is all set to have the perfect night. First her parents are going out of town. And although they hired a babysitter, Kelly is excited to basically be on her own. And then there's the sleepover she's having—a virtual, webcam sleepover where she and her friends can scare each other silly by telling ghost stories and summoning the spirit of Miss Mary, a woman from their small town who died tragically a long time ago. But when her friends start disappearing one by one and the babysitter is nowhere to be found, Kelly starts getting scared . . . for real. Is Miss Mary's ghost kidnapping everyone? Will Kelly be next?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      P. J. Night\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("A lifelong night owl, P.J. Night often works furiously into the wee hours of the morning, writing down spooky tales and dreaming up new stories of the supernatural and otherworldly. Although P.J.’s whereabouts are unknown at this time, we suspect the author lives in a drafty, old mansion where the floorboards creak when no one is there and the flickering candlelight creates shadows that creep along the walls. We truly wish we could tell you more, but we’ve been sworn to keep P.J.’s identity a secret…and it’s a secret we will take to our graves!")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Simon Spotlight\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0